<template>
  <v-app id="app">
    <AppBarMenu />

    <v-main>
      <v-container fluid>
        <BackButton
          v-if="isBackButtonVisible"
          style="position: fixed; z-index: 1;"
        />

        <router-view class="mt-5" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppBarMenu from "@/components/AppBarMenu.vue";
import BackButton from "@/components/BackButton.vue";

export default {
  name: "App",

  components: {
    AppBarMenu,
    BackButton
  },

  computed: {
    isBackButtonVisible() {
      return "Menu" !== this.$route.name;
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main-container {
  max-width: 1000px;
}
</style>
